<template>
  <div class="header">
    <a href="/">
      <div class="logo">
        <div style="padding: 30px;font-size: 20px;color:#FFF;">出口价管理平台</div>
        <!-- <img src="../../assets/img/logo.png" alt="" /> -->
      </div>
    </a>
    <el-menu
      id="my-header-setting"
      style="float: right"
      class="el-menu-demo"
      mode="horizontal"
      background-color="#485b7f"
      text-color="#cacfda"
      active-text-color="#cacfda"
    >
      <el-submenu index="setting" popper-class="popper-class">
        <template slot="title">{{ myName }}</template>
        <el-menu-item index="reset"
          ><div @click="isChangePWD = true">修改密码</div></el-menu-item
        >
        <el-menu-item index="logout"
          ><div @click="logout()">退出系统</div></el-menu-item
        >
      </el-submenu>
    </el-menu>

    <el-dialog
      title="修改密码"
      :visible.sync="isChangePWD"
      width="500"
      :before-close="handleClose"
      :show-close="false"
    >
      <el-form :model="form" ref="form">
        <el-form-item label="原密码" label-width="18%" prop="pwd">
          <el-input
            type="password"
            v-model="form.pwd"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" label-width="18%" prop="password">
          <el-input
            type="password"
            v-model="form.password"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="确认密码"
          label-width="18%"
          prop="password_confirmation"
        >
          <el-input
            type="password"
            v-model="form.password_confirmation"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isChangePWD = false">取 消</el-button>
        <el-button type="primary" @click="changePwd()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "my-header",
  data() {
    return {
      myName: "",
      isChangePWD: false,
      form: {},
    };
  },
  created() {
    console.log(JSON.parse(window.localStorage.getItem("user")))
    this.myName = JSON.parse(window.localStorage.getItem("user")).name;
  },
  mounted() {
  },
  methods: {
    logout() {
      let storage = window.localStorage;
      this.$message.success("退出成功");
      storage.clear();
      this.$router.push("/login");
    },
    handleClose() {
      this.form = {};
    },
    changePwd() {
      this.axios
        .put(this.api.reset, this.form)
        .then((e) => {
          if (e.code == 500) {
            this.$message.error(e.msg);
            return;
          }
          this.$message.success(e.msg);
          this.handleClose();
          this.isChangePWD = false;
        })
        .catch((e) => {});
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  margin: 0 auto;
  width: 100%;
  height: 60px;
  -webkit-user-select: none;
  user-select: none;
}

.logo {
  float: left;
  margin-left: 15px;
  img {
    float: left;
    margin-top: 10px;
    width: 150px;
  }
  span {
    float: left;
    margin-top: 18px;
    margin-left: 5px;
    font-family: "Arial Negreta", "Arial Normal", "Arial";
    font-weight: 700;
    font-style: normal;
    font-size: 16px;
    color: #c1c7d4;
  }
}

.el-menu {
  float: left;
  margin-left: 10px;
  margin-right: 5%;
}

.user {
  float: right;
  margin-top: 18px;
  margin-left: 5px;
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  color: #ffffff;
}
.popper-class {
  width: 100px;
}
</style>
<style lang="scss">
#my-header-setting {
  .el-button--primary:focus,
  .el-button--primary:hover {
    background-color: #439ec5;
  }
  .el-menu--horizontal .el-submenu .el-submenu__title {
    border-bottom: none;
  }
  .el-submenu__title {
    border-bottom: none;
  }
  .titleAdminB .el-menu--horizontal {
    border-bottom: none;
  }
  .el-menu--horizontal .el-submenu > .el-menu {
    width: 100px;
  }
  .el-menu--horizontal .el-submenu > .el-menu li {
    width: 100px;
  }
  .el-submenu .el-menu-item {
    min-width: 130px;
    width: 100%;
  }
  .el-menu--horizontal > .el-menu-item.is-active,
  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: none;
  }
}
</style>
